import { render } from "./OpenedMenu.vue?vue&type=template&id=07bef4c0&scoped=true"
import script from "./OpenedMenu.vue?vue&type=script&lang=js"
export * from "./OpenedMenu.vue?vue&type=script&lang=js"

import "./OpenedMenu.vue?vue&type=style&index=0&id=07bef4c0&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bef4c0"]])

export default __exports__